import requester from '../resources/requester';

const Tracker = async (body) => {
  await requester('POST', '/v1/public/tracker', body);
};

export default Tracker;
